import React, { useState } from 'react';
import styles from './add-comment-modal.module.scss';
import Modal from '../../../../../shared/components/core-ui/modal/modal.component';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { TextArea } from '../../../../../shared/components/core-ui/text-area/text-area.component';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select, { ValueType } from 'react-select';

export interface AddCommentModalProps {
  config: {
    showModal: boolean;
    showSkipEmail: boolean;
    isCancellation: boolean;
  };

  eventHandlers: {
    closeHandler: () => void;
    ChangeStatusWithComment: () => void;
    handelChange: (value: string) => void;
    handleReasonChange: (value: string) => void;
    handelSkipEmail: (value: boolean) => void;
  };
}

/**
 * functional component AddCommentModalProps
 * @param {AddCommentModalProps}
 */
type CancellationReasonOption = { value: string; label: string };

const CANCELLATION_REASON_OPTIONS: CancellationReasonOption[] = [
  { value: 'Change of Plans', label: 'Change of Plans' },
  { value: 'Found Better Price', label: 'Found Better Price' },
  { value: 'Better Alternative Found', label: 'Better Alternative Found' },
  { value: 'Stay Policy', label: 'Stay Policy' },
  { value: 'Personal Reason', label: 'Personal Reason' }
];

export const AddCommentModal: React.FC<AddCommentModalProps> = ({ eventHandlers, config }) => {
  const [Comment, setComment] = useState<string>('');
  const [cancellationReason, setCancellationReason] = useState<string>('');
  const [skipEmail, setSkipEmail] = useState<boolean>(false);

  const isCommentValid = Comment.trim().length > 0;
  const isCancellationReasonValid = cancellationReason.trim().length > 0;
  const canSubmit = !config.isCancellation || (isCommentValid && isCancellationReasonValid);

  const isMobileView = useWindowResizer();

  const handleSkipEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    eventHandlers.handelSkipEmail(event.target.checked);
    setSkipEmail(event.target.checked);
  };

  return (
    <Modal
      config={{ showModal: config.showModal, fullScreen: false, showClose: true }}
      eventHandlers={{
        closeModalHandler: () => {
          eventHandlers.closeHandler();
        }
      }}
    >
      <div className={styles['add-comment-modal']}>
        <div className={styles['add-comment-modal__title']}>
          {config.isCancellation ? 'Cancellation details' : 'Add Comment'}
        </div>
        <div className={styles['add-comment-modal__description']}>
          {config.isCancellation && (
            <div className="my-3">
              <Select
                placeholder="Select cancellation reason..."
                value={
                  cancellationReason
                    ? { value: cancellationReason, label: cancellationReason }
                    : null
                }
                options={CANCELLATION_REASON_OPTIONS}
                onChange={(value: ValueType<CancellationReasonOption, false>) => {
                  const selectedValue = value?.value || '';
                  setCancellationReason(selectedValue);
                  eventHandlers.handleReasonChange(selectedValue);
                }}
              />
            </div>
          )}
          <TextArea
            data={{
              defaultValue: '',
              placeholder: 'add your comment'
            }}
            config={{
              autoFocus: true
            }}
            eventHandlers={{
              onChangeHandler: (value: string) => {
                setComment(value);
                eventHandlers.handelChange(value);
              }
            }}
          />
          {config.showSkipEmail && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={skipEmail}
                  onChange={handleSkipEmailChange}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              }
              label="Do NOT send email to guest"
            />
          )}
        </div>
        <div className={styles['add-comment-modal--actions']}>
          <Button
            onClick={() => {
              eventHandlers.closeHandler();
            }}
            type={ButtonType.primaryInverted}
            size={isMobileView ? ButtonSize.full : ButtonSize.medium}
          >
            Cancel
          </Button>
          <Button
            onClick={eventHandlers.ChangeStatusWithComment}
            size={isMobileView ? ButtonSize.full : ButtonSize.medium}
            disabled={!canSubmit}
          >
            update status
          </Button>
        </div>
      </div>
    </Modal>
  );
};
